var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.008 512.008",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3C129"
    },
    d: "M273.656,427.5H25.075C11.226,427.5,0,416.274,0,402.425v-36.738 c0-13.849,11.226-25.075,25.075-25.075h248.58c13.849,0,25.075,11.226,25.075,25.075v36.738 C298.73,416.274,287.504,427.5,273.656,427.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6B41A"
    },
    d: "M273.656,402.915H25.075C11.226,402.915,0,391.689,0,377.84v24.585 c0,13.848,11.226,25.074,25.075,25.074h248.58c13.848,0,25.075-11.226,25.075-25.074V377.84 C298.73,391.689,287.504,402.915,273.656,402.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6B41A"
    },
    d: "M273.656,340.611H149.365v86.888h124.291c13.848,0,25.075-11.226,25.075-25.074v-36.738 C298.73,351.837,287.504,340.611,273.656,340.611z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAE246"
    },
    d: "M301.593,341.454H53.012c-13.849,0-25.075-11.226-25.075-25.075V279.64 c0-13.848,11.226-25.075,25.075-25.075h248.58c13.848,0,25.075,11.226,25.075,25.075v36.738 C326.667,330.228,315.441,341.454,301.593,341.454z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3C129"
    },
    d: "M301.593,316.869H53.012c-13.849,0-25.075-11.226-25.075-25.075v24.585 c0,13.848,11.226,25.074,25.075,25.074h248.58c13.848,0,25.075-11.226,25.075-25.074v-24.585 C326.667,305.643,315.441,316.869,301.593,316.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3C129"
    },
    d: "M301.593,254.565H177.302v86.888h124.291c13.848,0,25.075-11.226,25.075-25.074V279.64 C326.667,265.791,315.441,254.565,301.593,254.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3C129"
    },
    d: "M273.656,255.408H25.075C11.226,255.408,0,244.182,0,230.333v-36.738 c0-13.848,11.226-25.075,25.075-25.075h248.58c13.849,0,25.075,11.226,25.075,25.075v36.738 C298.73,244.182,287.504,255.408,273.656,255.408z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6B41A"
    },
    d: "M273.656,230.823H25.075C11.226,230.823,0,219.597,0,205.748v24.585 c0,13.848,11.226,25.074,25.075,25.074h248.58c13.848,0,25.075-11.226,25.075-25.074v-24.585 C298.73,219.597,287.504,230.823,273.656,230.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6B41A"
    },
    d: "M273.656,168.519H149.365v86.888h124.291c13.848,0,25.075-11.226,25.075-25.074v-36.738 C298.73,179.745,287.504,168.519,273.656,168.519z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAE246"
    },
    d: "M301.593,168.64H53.012c-13.849,0-25.075-11.226-25.075-25.075v-36.738 c0-13.848,11.226-25.075,25.075-25.075h248.58c13.848,0,25.075,11.226,25.075,25.075v36.738 C326.667,157.414,315.441,168.64,301.593,168.64z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3C129"
    },
    d: "M301.593,144.055H53.012c-13.849,0-25.075-11.226-25.075-25.075v24.585 c0,13.848,11.226,25.074,25.075,25.074h248.58c13.848,0,25.075-11.226,25.075-25.074V118.98 C326.667,132.829,315.441,144.055,301.593,144.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3C129"
    },
    d: "M301.593,81.751H177.302v86.888h124.291c13.848,0,25.075-11.226,25.075-25.074v-36.738 C326.667,92.977,315.441,81.751,301.593,81.751z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAD52D"
    },
    cx: 362.533,
    cy: 280.782,
    r: 149.474
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3C129"
    },
    d: "M362.53,131.316v298.941c82.551,0,149.47-66.919,149.47-149.47S445.081,131.316,362.53,131.316z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAE246"
    },
    cx: 362.533,
    cy: 280.782,
    r: 117.783
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6B41A"
    },
    d: "M357.014,345.848c-23.226-0.773-42.194-12.775-42.194-25.162c0-6.581,5.805-16.258,13.161-16.258 c8.129,0,14.709,11.42,29.032,13.936v-31.355c-17.807-6.775-38.711-15.097-38.711-39.872c0-24.581,18.194-36.389,38.711-39.291 v-5.42c0-2.71,3.097-5.226,7.355-5.226c3.677,0,7.354,2.517,7.354,5.226v4.839c12.001,0.387,34.646,3.483,34.646,16.838 c0,5.226-3.484,15.87-12.001,15.87c-6.388,0-10.064-6.193-22.646-7.161v28.259c17.614,6.581,38.13,15.677,38.13,41.806 c0,24.001-15.484,38.517-38.13,42.195v5.612c0,2.71-3.678,5.226-7.354,5.226c-4.259,0-7.355-2.517-7.355-5.226v-4.836H357.014z M358.95,256.428v-23.032c-8.711,1.742-12.387,6.194-12.387,10.838C346.562,249.847,351.594,253.33,358.95,256.428z M369.788,292.234v25.937c6.581-1.549,11.806-5.226,11.806-12.194C381.595,299.59,376.757,295.525,369.788,292.234z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.16c68110c652657bb8c34a4a6a21d4f0.svg";
export { ForwardRef as ReactComponent };